<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm"
             size="small">
      <el-form-item label="选择商品" prop="goods_id">
        <el-button type="text" @click="showModal=true" v-if="!info.id">选择商品</el-button>
        <div class="goods-box" v-if="goodsInfo">
          <div class="item one">
            <img :src="goodsInfo.img" class="img">
            <div class="name">{{ goodsInfo.title }}</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="活动时间" prop="dateRange">
        <el-date-picker
            size="small"
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="设置价格" prop="price">
        <el-table
            :data="tableData"
            ref="rfTable"
            border
            size="mini">
          <el-table-column
              prop="img"
              label="图片"
              align="center"
              width="100">
            <template slot-scope="scope">
              <el-avatar shape="square" :size="60" :src="scope.row.img"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
              prop="price"
              label="原价"
              align="center"
              width="140">
            <template slot-scope="scope">
              ￥{{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column
              prop="stock"
              label="库存"
              align="center"
              width="140">
            <template slot-scope="scope">
              {{ scope.row.stock }}
            </template>
          </el-table-column>
          <el-table-column
              prop="seckill_price"
              label="秒杀价"
              align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.seckill_price" autocomplete="off" placeholder="请输入价格">
                <template slot="append">元</template>
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="单次限购数量" prop="limit_single">
        <el-input v-model="info.limit_single" placeholder="请输入数量">
          <template slot="append">件，0为不限制</template>
        </el-input>
      </el-form-item>
      <el-form-item label="总限购次数" prop="limit_total">
        <el-input v-model="info.limit_total" placeholder="请输入数量">
          <template slot="append">件，0为不限制</template>
        </el-input>
      </el-form-item>
      <el-form-item label="参与佣金推广" prop="is_guider">
        <el-switch
            v-model="info.is_guider"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
        title="选择商品"
        :visible.sync="showModal"
        :destroy-on-close="true"
        width="900px">
      <goods-list :type="1" :goodsType="1" :selectFunc="setGoods"></goods-list>
    </el-dialog>
  </div>
</template>
<script>

import goodsList from "@/components/Goods/GoodsList";

export default {
  data() {
    return {
      showModal: false,
      dateRange: ['', ''],
      goodsInfo: false,
      tableData: [],
      info: {
        id: 0,
        goods_id: '',
        limit_total: '',
        limit_single: '',
        is_guider: '',
        price_content: []
      },
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        goods_id: [
          {required: true, message: '请选择商品', trigger: 'blur'}
        ]
      }
    };
  },
  components: {
    goodsList
  },
  created() {
    if (this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    setGoods(goods) {
      this.goodsInfo = goods
      this.info.goods_id = goods.id
      this.showModal = false
      this.getGoodsInfo()
    },
    getPrice(specs_id) {
      let price = ''
      if (this.info.price_content && this.info.price_content.length > 0) {
        this.info.price_content.forEach(item => {
          if (item.specs_id == specs_id) {
            price = item.seckill_price
          }
        })
      }
      return price
    },
    getGoodsInfo() {
      this.tableData = []
      let loading = this.$loading({
        text: '加载中..',
      })
      this.$api.goods.goodsInfo({id: this.info.goods_id}, res => {
        loading.close()
        if (res.errcode == 0) {
          if (res.data.is_sku == 1) {
            res.data.specsList.forEach(item => {
              this.tableData.push({
                goods_id: this.info.goods_id,
                specs_id: item.id,
                img: item.img,
                stock: item.stock,
                price: item.price,
                seckill_price: this.getPrice(item.id)
              })
            })
          } else {
            this.tableData.push({
              goods_id: res.data.id,
              specs_id: 0,
              img: res.data.img,
              stock: res.data.stock,
              price: res.data.price,
              seckill_price: this.getPrice(0)
            })
          }
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getInfo() {
      this.showLoading()
      this.$api.marking.seckillInfo({id: this.info.id}, res => {
        this.hideLoading()
        if (res.errcode == 0) {
          this.info = res.data
          this.goodsInfo = this.info.goods
          this.dateRange = [this.info.start_time, this.info.end_time]
          this.getGoodsInfo()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            id: this.info.id,
            goods_id: this.goodsInfo.id,
            start_time: this.dateRange[0],
            end_time: this.dateRange[1],
            limit_single: this.info.limit_single,
            limit_total: this.info.limit_total,
            is_guider: this.info.is_guider,
          }
          if (param.start_time == '') {
            this.fail('活动时间不能为空')
            return false;
          }
          param.price_content = this.tableData
          let error = ''
          param.price_content.forEach(item => {
            if (item.seckill_price == '') {
              error = '请输入秒杀价'
            } else if (parseFloat(item.seckill_price) <= 0) {
              error = '秒杀价必须大于0'
            } else if (parseFloat(item.seckill_price) > parseFloat(item.price)) {
              error = '秒杀价必须小于商品价'
            }
          })
          if (error) {
            this.fail(error)
            return false
          }
          this.$api.marking.seckillEdit(param, function (res) {
            if (res.errcode == 0) {
              that.success(res.errmsg)
              that.reBack()
            } else {
              that.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.box {
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  min-height: 500px;
}

.ruleForm {
  width: 700px;
}
</style>
